import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faStore,
  faCalendarDay,
  faBuilding,
  faRupeeSign,
  faLock,
  faKey,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
// import styles from "./leaseMenu.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
class LeaseMenu extends React.Component {
    state = {
    openMenu: ["1"],
    disableOption: false,
    urlAppend: "",
    activeKey: "1-1",
    propsMenu: ","

    };
    constructor(props) {
    super(props);
    //console.log(this.props.openMenu);
    this.state = {
      openMenu: [this.props.openMenu],
      disableOption: false,
      urlAppend: "",
      activeKey: "1-1",
      propsActiveKey: "1-1",
      propsMenu: ",",

    };
    }

    componentDidMount() {
    if (this.props.match.params.id === undefined) {
      this.setState({
        disableOption: true,
      });
    } else {
      this.setState({
        disableOption: false,
        urlAppend: "/" + this.props.match.params.id,
        });
        }   
    }

    componentDidUpdate() {
        if (this.props.openMenu != this.state.propsMenu) {
          this.setState({
            propsMenu: this.props.openMenu,
            openMenu: [this.props.openMenu],
          });
        }
        if (this.props.activeKey != this.state.propsActiveKey) {
          this.setState({
            propsActiveKey: this.props.activeKey,
            activeKey: this.props.activeKey,
          });
        }
        if (this.props.match.params.id === undefined) {
          if (this.state.disableOption == false) {
            this.setState({
              disableOption: true,
            });
          }
        } else {
          if (this.state.disableOption == true) {
            this.setState({
              disableOption: false,
              urlAppend: "/" + this.props.match.params.id,
            });
          }
        }
      }

        render() {
        // let url = this.props.match;
        //console.log("rendering menu");
        return (
            <div className="leftSidebar">
        <Sidenav
        activeKey={this.state.activeKey}
        openKeys={this.state.openMenu}
        onOpenChange={(openKeys, event) => {
          console.log(openKeys[openKeys.length - 1]);
          this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
        }}
        >
            <Sidenav.Body>
            <Nav>
            <Dropdown
                eventKey="1"
                title="Asset Details" 
                // icon={<FontAwesomeIcon icon={faBuilding} />}
            >
                <Dropdown.Item
                  eventKey="1-1"
                  componentClass={Link}
                  to={`/close-deals/asset-details` + this.state.urlAppend}
                  // disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "1-1";
                  }}
                >
                    Asset Details
                </Dropdown.Item>
            </Dropdown>
            

            <Dropdown
             eventKey="2"
             title="Acquisition Details"
            //  icon={<FontAwesomeIcon icon={faKey} />}
            >
                <Dropdown.Item
                  componentClass={Link}
                  to={`/close-deals/acquisition-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "2-1";
                  }}
                  eventKey="2-1"
                >
                  Acquisition Details
                </Dropdown.Item>
            </Dropdown>

            <Dropdown
             eventKey="3"
             title="Asset Management"
            //  icon={<FontAwesomeIcon icon={faBuilding} />}
            >
                <Dropdown.Item
                  componentClass={Link}
                  to={`/close-deals/asset-management` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "3-1";
                  }}
                  eventKey="3-1"
                >
                Asset Management
                </Dropdown.Item>
            </Dropdown>

            <Dropdown
             eventKey="4"
             title="Valuation"
            //  icon={<FontAwesomeIcon icon={faRupeeSign} />}
            >
                <Dropdown.Item
                  componentClass={Link}
                  to={`/close-deals/valuation` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "4-1";
                  }}
                  eventKey="4-1"
                >
                Valuation 
                </Dropdown.Item>
            </Dropdown>
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
}
}

export default withRouter(LeaseMenu);